import {API_URL} from 'api/constants'
export const V1_RECIPES = `${API_URL}/v1/recipes`
export const V1_IMPORT_RECIPES_TEMPLATE = `${V1_RECIPES}/import_recipes_template`
export const V1_EXPORT_RECIPES = `${V1_RECIPES}/export`
export const V1_GET_ITEM_DROPDOWN = `${API_URL}/v1/items/item_dropdowns`
export const GET_ITEM_VARIANT = (id) => `${API_URL}/v1/recipes/item_variants/${id}`
export const GET_ITEM_INGREDIENT = (page, perPage, keyword) => `${API_URL}/v1/ingredients?page=${page}&per_page=${perPage}&keyword=${keyword}`
export const DELETE_RECIPES_BY_ID = (id) => `${API_URL}/v1/recipes/${id}`
export const CREATE_RECIPES = `${API_URL}/v1/recipes`
export const CREATE_ALL_OUTLET_RECIPES = `${API_URL}/v1/recipes/create_all_outlets`
export const UPDATE_RECIPES = (id) => `${API_URL}/v1/recipes/${id}`
export const UPDATE_RECIPES_ALL_OUTLET = (id) => `${API_URL}/v1/recipes/${id}/update_all_outlets`
export const GET_RECIPE_BY_VARIANT_ID = (id) => `${API_URL}/v1/recipes/item_variant/${id}`



// WEBPACK FOOTER //
// ./app/api/ingredients/recipes/constants.js